import { useIsSignedIn } from "PFApp/hooks";
import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import api from "PFCore/api";
import { useProfileInvalidate } from "PFCore/hooks/queries/profile";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, useSearchParams } from "react-router";

export const EmailConfirmationController = (): any => {
  const [searchParams] = useSearchParams();
  const confirmationToken = searchParams.get("confirmation_token");

  const [complete, setComplete] = useState(false);

  const { isSignedIn } = useIsSignedIn();
  const { invalidateCurrentProfile } = useProfileInvalidate();

  const { showGrowl } = useGrowlStoreActions();
  const { t } = useTranslation();

  useEffect(() => {
    if (!confirmationToken) {
      return;
    }
    api({
      url: "auth/confirmation",
      apiVersion: 1,
      headers: {
        "Content-Type": "multipart/form-data"
      },
      method: "post",
      data: { "user[confirmation_token]": confirmationToken }
    })
      .then(() => {
        if (isSignedIn) {
          showGrowl({
            message: t("emailConfirmation.emailChanged"),
            kind: "success"
          });
          invalidateCurrentProfile();
        } else {
          showGrowl({
            title: t("emailConfirmation.emailChanged"),
            message: t("emailConfirmation.canLoginWithNew"),
            kind: "alert"
          });
        }

        setComplete(true);
      })
      .catch(() => {
        showGrowl({
          title: t("error"),
          message: t("emailConfirmation.tokenExpiredError"),
          kind: "error"
        });

        setComplete(true);
      });
  }, []);

  if (complete) {
    return <Navigate to="/" replace />;
  }

  return null;
};
